import { requiredStringField } from '@utils/forms';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const prepaidCollect = t.union([t.literal(''), t.literal('PREPAID'), t.literal('COLLECT')]);

export const PREPAID_COLLECT = prepaidCollect.types
  .map((type) => type.value)
  .filter((v) => v !== '');

export const preAlertPaymentTerms = t.union([
  t.literal(''),
  t.literal('DDU'),
  t.literal('DDP'),
  t.literal('EXW'),
  t.literal('FCA'),
]);

export const PAYMENTS_TERMS = preAlertPaymentTerms.types.map((type) => type.value);

export const seaWaybill = t.type({
  booking_inquiry: t.number,
  id: t.number,
  house_bl_number: t.string,
  place_of_receipt: t.string,
  shipper: t.string,
  consignee: t.string,
  place_of_delivery: t.string,
  commodity: t.string,
  shipping_mark: t.string,
  prepaid_collect: h.omittable(t.string),
  payments_terms: t.string,
  nos: h.omittable(t.number),
  packages: t.string,
  gross_weight: h.omittable(t.string),
  chargeable_weight: t.string,
  measurement: h.omittable(t.string),
  vessel: t.string,
  voyage: t.string,
  pol: t.string,
  pod: t.string,
  etd: h.omittable(t.string),
  created_at: t.string,
  updated_at: t.string,
});

export type SeaWaybill = t.TypeOf<typeof seaWaybill>;

export type SeaWaybillInTable = Omit<
  SeaWaybill,
  'booking_inquiry' | 'house_bl_number' | 'created_at' | 'updated_at' | 'id'
>;

export const putSeaWaybill = t.type({
  place_of_receipt: t.string,
  shipper: t.string,
  consignee: t.string,
  place_of_delivery: t.string,
  commodity: t.string,
  shipping_mark: t.string,
  prepaid_collect: prepaidCollect,
  payments_terms: t.string,
  nos: t.number,
});

export type PutSeaWaybill = t.TypeOf<typeof putSeaWaybill>;

export const patchSeaWaybill = t.type({
  detail: t.string,
  place_of_receipt: h.omittable(t.string),
  shipper: h.omittable(t.string),
  consignee: h.omittable(t.string),
  place_of_delivery: h.omittable(t.string),
  commodity: h.omittable(t.string),
  shipping_mark: h.omittable(t.string),
  prepaid_collect: h.omittable(prepaidCollect),
  payments_terms: h.omittable(t.string),
  nos: h.omittable(t.number),
});

export type PatchSeaWaybill = t.TypeOf<typeof patchSeaWaybill>;

export const seaWaybillForm = t.type({
  place_of_receipt: requiredStringField('Place of Receipt'),
  shipper: requiredStringField('Shipper'),
  consignee: requiredStringField('Consignee'),
  place_of_delivery: requiredStringField('Place of  Delivery'),
  commodity: requiredStringField('Commodity'),
  shipping_mark: requiredStringField('Shipping Mark'),
  prepaid_collect: requiredStringField('Prepaid/Collect'),
  payments_terms: requiredStringField('Payment Terms'),
});

export const seaWaybillLog = t.array(
  t.type({
    id: t.number,
    sea_waybill: t.number,
    edited_field: t.string,
    before_value: t.string,
    after_value: t.string,
    detail: t.string,
    updated_at: t.string,
    created_at: t.string,
    editor: t.string,
  }),
);

export type SeaWaybillLog = t.TypeOf<typeof seaWaybillLog>;

export const seaWaybillExample = {
  data: {
    booking_inquiry: 30,
    house_bl_number: '1111',
    place_of_receipt:
      'ICAN Industrial Limited\nGuangdong, Shenzhen, Longgang, Longcheng, Xinlian\nWutong Space Work New Field,Bixin Road ,Longgang District,Shenzhen City ,Guangdong Province,China',
    shipper:
      'ICAN Industrial Limited\nGuangdong, Shenzhen, Longgang, Longcheng, Xinlian\nWutong Space Work New Field,Bixin Road ,Longgang District,Shenzhen City ,Guangdong Province,China',
    consignee: 'グリーンライト アパートメント\n大阪府豊中市服部寿町4-5-23X-tech内',
    place_of_delivery: 'グリーンライト アパートメント\n大阪府豊中市服部寿町4-5-23X-tech内',
    commodity: 'skateboard deck',
    shipping_mark: 'Y-33070429Y-33070429Y-33070429Y-33070429Y-33070429Y-33070429',
    prepaid_collect: 'PREPAID',
    payments_terms: 'DDU',
    nos: 1,
    packages: 'BUNDLE',
    gross_weight: 'sample gross_weight',
    chargeable_weight: 'sample gross_weight',
    measurement: 'sample measurement',
    vessel: 'ZHONG HE',
    voyage: '2152E',
    pod: 'Shanghai',
    pol: 'Tokyo',
    etd: '2022-01-01',
    created_at: '2022-01-01T04:26:58.470Z',
    updated_at: '2022-01-01T04:26:58.470Z',
  } as SeaWaybill,
  isLoading: false,
  isSuccess: true,
  error: undefined,
};
